const SEO_PARAGRAPH_ELEMENT_ID_AT_PAGE_TOP = 'seo-root';

const PAGE_TYPES = {
  DYNAMIC: 'dynamicpage',
  STATIC: 'static',
  BRAND: 'brandpage',
  TAG: 'taggedproduct',
  DICTIONARY: 'dictionary',
  MERCHANT: 'merchant',
  BRAND_DESKTOP:'brand',
  CATEGORY: 'category',
  SEARCH: 'search',
}

export {
  SEO_PARAGRAPH_ELEMENT_ID_AT_PAGE_TOP,
  PAGE_TYPES,
}
